export var SwapEventTypeEnum;
(function (SwapEventTypeEnum) {
    // Lifecycle events (system)
    SwapEventTypeEnum["CREATED"] = "created";
    SwapEventTypeEnum["STATUS_CHANGED"] = "status_changed";
    // Retry events
    SwapEventTypeEnum["AUTO_RETRY_ATTEMPTED"] = "auto_retry_attempted";
    SwapEventTypeEnum["AUTO_RETRY_EXHAUSTED"] = "auto_retry_exhausted";
    SwapEventTypeEnum["MANUAL_RETRY_REQUESTED"] = "manual_retry_requested";
    // Admin interventions
    SwapEventTypeEnum["PAUSED"] = "paused";
    SwapEventTypeEnum["RESUMED"] = "resumed";
    SwapEventTypeEnum["CANCELLED"] = "cancelled";
    SwapEventTypeEnum["FORCE_COMPLETED"] = "force_completed";
    // Reservation events
    SwapEventTypeEnum["RESERVATION_CREATED"] = "reservation_created";
    SwapEventTypeEnum["RESERVATION_CONFIRMED"] = "reservation_confirmed";
    SwapEventTypeEnum["RESERVATION_CONSUMED"] = "reservation_consumed";
    SwapEventTypeEnum["RESERVATION_RELEASED"] = "reservation_released";
    SwapEventTypeEnum["RESERVATION_EXPIRED"] = "reservation_expired";
    SwapEventTypeEnum["RESERVATION_HELD"] = "reservation_held";
    // Order events
    SwapEventTypeEnum["ORDER_PLACED"] = "order_placed";
    SwapEventTypeEnum["ORDER_FILLED"] = "order_filled";
    SwapEventTypeEnum["ORDER_FAILED"] = "order_failed";
    // Deposit events
    SwapEventTypeEnum["DEPOSIT_REBALANCING_COMPLETED"] = "deposit_rebalancing_completed";
    SwapEventTypeEnum["DEPOSIT_DETECTED"] = "deposit_detected";
    SwapEventTypeEnum["DEPOSIT_CONFIRMED"] = "deposit_confirmed";
    SwapEventTypeEnum["DEPOSIT_FAILED"] = "deposit_failed";
    // Notes/comments
    SwapEventTypeEnum["ADMIN_NOTE_ADDED"] = "admin_note_added";
})(SwapEventTypeEnum || (SwapEventTypeEnum = {}));
export var SwapEventEntityTypeEnum;
(function (SwapEventEntityTypeEnum) {
    SwapEventEntityTypeEnum["SWAP"] = "swap";
    SwapEventEntityTypeEnum["TRANCHE"] = "tranche";
    SwapEventEntityTypeEnum["RESERVATION"] = "reservation";
})(SwapEventEntityTypeEnum || (SwapEventEntityTypeEnum = {}));
export var SwapEventTriggeredByEnum;
(function (SwapEventTriggeredByEnum) {
    SwapEventTriggeredByEnum["SYSTEM"] = "system";
    SwapEventTriggeredByEnum["ADMIN"] = "admin";
    SwapEventTriggeredByEnum["SCHEDULER"] = "scheduler";
})(SwapEventTriggeredByEnum || (SwapEventTriggeredByEnum = {}));
//# sourceMappingURL=swap-event-type.enum.js.map